import { Phone, MapPin, Clock, Truck } from "lucide-react";
import { PHONE, PHONE_TEL } from "@/lib/api";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <section className="bg-navy">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-center">
          <h1 className="font-display font-black text-white text-4xl md:text-5xl tracking-tighter">CONTACT</h1>
          <p className="text-white/70 mt-3">Suntem aici pentru tine. Comandă rapid, telefonic!</p>
        </div>
      </section>

      <section className="bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid sm:grid-cols-2 gap-6">
            <a
              href={PHONE_TEL}
              className="bg-slate-50 border-2 border-slate-100 rounded-2xl p-7 hover:border-eco/30 transition-colors"
              data-testid="contact-phone"
            >
              <span className="bg-eco rounded-full h-12 w-12 flex items-center justify-center mb-4">
                <Phone className="h-6 w-6 text-white" />
              </span>
              <h3 className="font-display font-black text-navy text-lg">Telefon</h3>
              <p className="font-display font-black text-navy text-2xl mt-1">{PHONE}</p>
              <p className="text-sm text-muted-foreground">Comandă în doar câteva minute!</p>
            </a>

            <div className="bg-slate-50 border-2 border-slate-100 rounded-2xl p-7">
              <span className="bg-navy rounded-full h-12 w-12 flex items-center justify-center mb-4">
                <Clock className="h-6 w-6 text-gold" />
              </span>
              <h3 className="font-display font-black text-navy text-lg">Program</h3>
              <p className="text-sm text-slate-700 mt-1">Luni - Vineri: 09:00 - 18:00</p>
              <p className="text-sm text-slate-700">Sâmbătă: 09:00 - 14:00</p>
            </div>

            <div className="bg-slate-50 border-2 border-slate-100 rounded-2xl p-7">
              <span className="bg-navy rounded-full h-12 w-12 flex items-center justify-center mb-4">
                <Truck className="h-6 w-6 text-gold" />
              </span>
              <h3 className="font-display font-black text-navy text-lg">Livrare</h3>
              <p className="text-sm text-slate-700 mt-1">1-2 zile lucrătoare</p>
              <p className="text-sm text-slate-700">Plata la livrare (ramburs)</p>
            </div>

            <div className="bg-slate-50 border-2 border-slate-100 rounded-2xl p-7">
              <span className="bg-navy rounded-full h-12 w-12 flex items-center justify-center mb-4">
                <MapPin className="h-6 w-6 text-gold" />
              </span>
              <h3 className="font-display font-black text-navy text-lg">Origine</h3>
              <p className="text-sm text-slate-700 mt-1">Fabricat în România</p>
              <p className="text-sm text-slate-700">Produse testate și aprobate</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
